<template>
    <div class="home-wrapper">
        <navbar></navbar>
        <div class="home-body">
            <div class="home-content">
                <div>
                    <div>优品淘金</div>
                    <div class="subtitle">
                        <div>超省钱购物神器</div>
                        <div>分享还可赚收益</div>
                    </div>
                    <div class="flex">
                        <div id="qrcode" class="code-img"></div>
                        <div>
                            <div :class="isIOS ? 'mobile-block mobile-block-selected' : 'mobile-block mobile-block-notselected'" @click="handleChangeMobile('ios')">
                                <img :src="isIOS ? require('../assets/pc/home/IOS_red.png') : require('../assets/pc/home/IOS_white.png')" class="mobile-img"/>
                                iPhone版下载
                            </div>
                            <div :class="isIOS ? 'mobile-block mobile-block-notselected' : 'mobile-block mobile-block-selected'" @click="handleChangeMobile('android')">
                                <img :src="isIOS ? require('../assets/pc/home/android_white.png') : require('../assets/pc/home/android_red.png')" class="mobile-img"/>
                                Android版下载
                            </div>
                        </div>
                    </div>
                </div>
                <img src="../assets/pc/home/home.png" class="home-img"/>
            </div>
            <record color="#ffffff"></record>
        </div>
    </div>
</template>

<script>
    import {getVersionLink} from '@/api/requestApi.js'

    import navbar from "./navbar";
    import record from "./record";

    import QRCode from 'qrcodejs2'
    export default {
        name: "home",
        components:{
            navbar,
            record
        },
        data(){
            return {
                isIOS: true,
                qrcode: null,
                iosLink: '',
                androidLink: ''
            }
        },
        mounted(){
            this.getLink();
        },
        methods:{
            getLink(){
                getVersionLink().then((data)=>{
                    this.iosLink = 'https://itunes.apple.com/cn/app/apple-store/id1572797930';
                    this.androidLink = 'https://mall.ujtao.com/#/download';

                    this.qrcode = new QRCode(document.getElementById('qrcode'), {
                        text: this.iosLink, //要生成二维码的网址
                        width: 110,  //图像宽度
                        height: 110, //图像高度
                        colorDark: '#000000',  //前景色
                        colorLight: '#ffffff', //背景色
                        margin: 0, //外边距
                        correctLevel: QRCode.CorrectLevel.L //容错级别。属性值有：QRCode.CorrectLevel.L、QRCode.CorrectLevel.M、QRCode.CorrectLevel.Q、QRCode.CorrectLevel.H
                    })
                })
            },
            handleChangeMobile(val){
                if(val === 'android'){
                    this.isIOS = false;
                    this.qrcode.makeCode(this.androidLink);
                }else{
                    this.isIOS = true;
                    this.qrcode.makeCode(this.iosLink);
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    .flex{
        display: flex;
        align-items: center;
    }
    @mixin width-height($width: 100%, $height: 100%){
        width: $width;
        height: $height;
    }
    @mixin font($size: 40px,$color:black,$weight:400){
        font-size: $size;
        color: $color;
        font-weight: $weight;
    }
    @mixin flex($ai:center){
        display: flex;
        align-items: $ai;
    }
    .home-wrapper{
        @include width-height;
        @include font;
        display: flex;
        flex-direction: column;

        .home-body{
            z-index: 1;
            flex: 1;
            position: relative;
            background-image: url('../assets/pc/home/bg.png');
            background-size:100% 100%;
            @include flex(flex-start);
            justify-content: flex-end;

            .home-content{
                @include flex;
                @include font(54px,#ffffff,300);

                .subtitle{
                    @include font(65px,#ffffff,600);
                    margin: 30px 0 60px;
                }
                .code-img{
                    @include width-height(159px,154px);
                    padding: 4px 5px;
                    background-color: #fff;
                    border-radius: 20px;
                    @include flex;
                    justify-content: center;
                    margin-right: 40px;
                }
                .mobile-block{
                    font-size: 18px;
                    font-weight: 500;
                    padding: 12px 20px;
                    border-radius: 22px;
                    margin-bottom: 15px;
                    @include flex;
                    cursor: pointer;
                    &:last-child{
                        margin-bottom: 0;
                    }
                }
                .mobile-block-selected{
                    border: none;
                    color: #FA0655;
                    background: #ffffff;
                }
                .mobile-block-notselected{
                    border: 1px solid #ffffff;
                    color:#ffffff;
                    background: transparent;
                }
                .mobile-img{
                    @include width-height(20px,20p);
                    margin-right: 10px;
                }
                .home-img{
                    z-index: -1;
                    position: relative;
                    top: -88px;
                    @include width-height(1108px,940px);
                }
            }
        }
    }
</style>
